import emailMisspelled, { all /*, aol, hotmail, live, microsoft, more, outlook, top100, yahoo*/ } from 'email-misspelled';

import { DataTypeEvaluator } from '@ply-io/data-types';

import { ORIGINS, ORIGINS_TO_RETURN_URL_MAP } from './userRegistration.const';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import UserAgentService from '@/utils/user-agent-service';
import { LANDING_PAGE_ROUTE } from '@/views/userRegistration/helpers/userRegistration.const';

const isMobile = require('is-mobile');

const evaluator = new DataTypeEvaluator();

const domainsToCheck = [...new Set(['ply.io', 'tross.co', 'biggercake.com', ...all])];
export const emailChecker = emailMisspelled({ domains: domainsToCheck, maxMisspelled: 2, lengthDiffMax: 3 });

let auth2;

function getRequiredRules() {
	return [(v) => !!v || 'Field is required'];
}

function getEmailValidationRules() {
	// eslint-disable-next-line no-useless-escape
	return [(v) => !!v || 'Email is required', (v) => evaluator.isEmail(v) || 'Email must be valid'];
}

function getNameRules() {
	return [(v) => v.length > 1 || 'Must be at least 2 characters'];
}

const passwordLengthValidation = (p) => p?.length >= 8 || 'Password must be at least 8 characters';
const passwordContainsNumberValidation = (p) => /\d/.test(p) || 'Password must contain at least one number';
const passwordContainsLetterValidation = (p) => /[a-zA-Z]/.test(p) || 'Password must contain at least one letter';
const passwordContainsSpecialCharValidation = (p) =>
	/[~`! @#$%^&*()_\-+={[}\]|:;"'<,>.?/]/.test(p) || 'Password must contain at least one special character';

function getPasswordValidationRules() {
	// return [];
	return [
		(p) => !!p || 'Password is required',
		passwordLengthValidation,
		passwordContainsNumberValidation,
		passwordContainsLetterValidation,
		passwordContainsSpecialCharValidation,
	];
}

function getPasswordValidationFuncs() {
	return [
		passwordLengthValidation,
		passwordContainsNumberValidation,
		passwordContainsLetterValidation,
		passwordContainsSpecialCharValidation,
	];
}

function getSignupReferrer(referrerURL) {
	console.log('*** referrerURL: ', referrerURL);
	const hostname = window.location.hostname;
	const isFromPlatform = referrerURL === '' || hostname === new URL(referrerURL).hostname;
	if (isFromPlatform) {
		if (referrerURL.includes('installables')) {
			return ORIGINS.MARKETPLACE;
		} else {
			return ORIGINS.LANDING_PAGE;
		}
	} else if (referrerURL.includes('chrome.google.com')) {
		return ORIGINS.CHROME_STORE;
	} else if (referrerURL.includes('plymail')) {
		return ORIGINS.PLY_MAIL;
	}
	return ORIGINS.OTHER;
}

async function initializeGoogleAuth() {
	return window.gapi.load('auth2', async () => {
		auth2 = window.gapi.auth2.init({
			client_id: process.env.VUE_APP_GOOGLE_SIGN_IN_CLIENT_ID,
		});
		auth2.then(
			() => {},
			(err) => {
				console.log(`Error!:`, err);
				auth2 = null;
			}
		);
	});
}
async function signInWithGoogleRedirect() {
	window.location.href = `${process.env.VUE_APP_API}google-login`;
}
async function signInWithGoogle(getFullUser) {
	if (!auth2) {
		return signInWithGoogleRedirect();
	}
	const googleUser = await auth2.signIn();
	if (getFullUser) {
		return googleUser;
	}
	return googleUser.getAuthResponse().id_token;
}

function getExtensionFirstPageAfterSignup(signupReferrer, returnToUrl) {
	const routePath = ORIGINS_TO_RETURN_URL_MAP[signupReferrer];
	return routePath || returnToUrl || LANDING_PAGE_ROUTE;
}

async function isExtensionInstalled() {
	return !!(await ExtensionCommunicationService.isInstalled());
}

const getNavigateToFirstPageObject = async (signupReferrer, returnToUrl) => {
	if (isMobile()) {
		return { name: 'MobileNotSupported' };
	}
	if (await isExtensionInstalled()) {
		return { path: await getExtensionFirstPageAfterSignup(signupReferrer, returnToUrl) };
	}
	if (!UserAgentService.isUsingChromium()) {
		return { name: 'InstallChrome' };
	}

	return { name: signupReferrer === ORIGINS.CHROME_STORE ? 'PinExtension' : 'InstallExtensionLink' };
};

const UserRegistrationService = {
	getPasswordValidationFuncs,
	getRequiredRules,
	getEmailValidationRules,
	getNameRules,
	getPasswordValidationRules,
	emailChecker,
	getSignupReferrer,
	initializeGoogleAuth,
	signInWithGoogle,
	getExtensionFirstPageAfterSignup,
	getNavigateToFirstPageObject,
};

export default UserRegistrationService;
